// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SwiperStyle } from "@rugby/App/Components/RugbyCarousel/RugbyCarousel";
import breakpoints from "@rugby/XDL/PreStyle/breakpoints";
import { color, MediaQuery } from "@rugby/XDL/Utilities";
import styled, { css } from "styled-components";

export const carouselArrowStyle = {
    button: (position: "next" | "prev") => {
        const positionSide = position === "prev" ? "left: 0;" : "right: 0";
        const factor = position === "prev" ? -1 : 1;
        return {
            size: 20,
            css: css`
                position: absolute;
                top: 50%;

                ${positionSide};

                transform: translate(${24 * factor}px, -50%);
                z-index: 1;

                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;

                &:focus {
                    box-shadow: none;
                }

                &&& {
                    background: transparent;
                    border: 0;
                    outline: none !important;
                }
            `,
        };
    },
    iconWrapper: {
        size: 14,
        css: css`
            &&& {
                top: 0;
                color: ${color("common.ui1")};
                &.disabled {
                    color: ${color("common.ui1", 0.5)};
                }
            }
        `,
    },
};

export const swiperStyle: SwiperStyle = {
    nextArrowSwiper: {
        ...carouselArrowStyle.button("next"),
    },
    nextArrowSwiperIcon: {
        ...carouselArrowStyle.iconWrapper,
    },
    prevArrowSwiper: {
        ...carouselArrowStyle.button("prev"),
    },
    prevArrowSwiperIcon: {
        ...carouselArrowStyle.iconWrapper,
    },
};

const arrowLine = (position: "next" | "prev") => {
    return css`
        &:before {
            content: "";
            width: 1px;
            height: 60px;
            background: ${color("common.border")};
            position: absolute;
            ${position === "prev" ? `right: -10px;` : `left: -10px;`}
        }
    `;
};

export const swiperStyleWithArrowLine: SwiperStyle = {
    mainContainer: {
        css: css`
            .swiper-container {
                max-width: calc(100% - 60px);

                ${MediaQuery.lte(1300)} {
                    max-width: calc(100% - 90px);
                }
            }
        `,
    },
    nextArrowSwiper: {
        ...carouselArrowStyle.button("next"),
        css: css`
            ${carouselArrowStyle.button("next").css}
            ${MediaQuery.lte(1300)} {
                transform: translateY(-50%);
            }

            ${arrowLine("next")}
        `,
    },
    prevArrowSwiper: {
        ...carouselArrowStyle.button("prev"),
        css: css`
            ${carouselArrowStyle.button("prev").css}
            ${MediaQuery.lte(1300)} {
                transform: translateY(-50%);
            }

            ${arrowLine("prev")}
        `,
    },
};
